import { defaultformstate } from './formstate'

export default {
    name:'',
    dobStart:'',
    dobEnd:'',
    men:false,
    women:false,
    offerGenderDivisionOptions:'Y',
    addDivisionMode:false,
    ...defaultformstate
}


// WEBPACK FOOTER //
// ./src/utils/statedefaultvalues/division.js